module.exports = __webpack_public_path__ + "img/wire-transfer-info.55b10c27.png";